module.exports = __webpack_public_path__ + "static/media/Logo_color_SKHU_EN_RGB.9a1e8558.jpg";